import axios from "axios";
import { errorToast } from "../../utils/constants";
import { CID } from "multiformats/cid";
import { base58btc } from "multiformats/bases/base58";
import { create } from "multiformats/hashes/digest";

export const pinFileToIpfs = async (
  fileInFormData,
  setUploadPercentage,
  readData
) => {
  try {
    setUploadPercentage(0); //reset %
    return await axios({
      method: "POST",
      url: "https://api.pinata.cloud/pinning/pinFileToIPFS",
      headers: {
        "Content-Type": "multipart/form-data",
        "content-type": "multipart/form-data",
        Authorization: `Bearer ${process.env.REACT_APP_PINATA_API_JWT}`,
      },
      data: fileInFormData,
      onUploadProgress: (e) => {
        const uploadPerc = Math.round((e.loaded / e.total) * 100);
        if (uploadPerc !== 100) {
          setUploadPercentage(uploadPerc.toFixed(2));
        }
      },
    }).then(async (res) => {
      //update % to 100 only when file is pinned
      if (readData) {
        const docData = await readIpfsDocumentFromHash(res.data.IpfsHash);
        setUploadPercentage(100);
        return {
          hash: res.data.IpfsHash,
          data: docData,
        };
      } else {
        setUploadPercentage(100);
        return res.data.IpfsHash;
      }
    });
  } catch (err) {
    errorToast("File upload error!", "Error while uploading file to ipfs");
    console.error("Error while uploading file to ipfs: ", err?.message);
    return;
  }
};

export const getIpfsUrlFromHash = (ipfsHash) => {
  return `${process.env.REACT_APP_PINATA_IPFS_GATEWAY}/${ipfsHash}`;
};

export const readIpfsDocumentFromHash = async (ipfsHash) => {
  try {
    return await axios({
      method: "GET",
      url: getIpfsUrlFromHash(ipfsHash),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }).then((res) => {
      return res.data;
    });
  } catch (err) {
    console.error("Error while reading ipfs file: ", err?.message);
    return {};
  }
};

export const convertIpfsHashToBytes32 = (ipfsHash) => {
  const cid = CID.parse(ipfsHash);
  const digest = cid.multihash.digest;
  if (digest.length !== 32) return null;
  return `0x${Buffer.from(digest)?.toString("hex")}`;
};

export const convertBytes32ToIpfsHash = (bytes32) => {
  const hex = bytes32.replace(/^0x/, "");
  const digestBytes = Uint8Array.from(Buffer.from(hex, "hex"));
  const multihash = create(0x12, digestBytes);
  const cid = CID.createV0(multihash);
  return cid.toString(base58btc);
};
